'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminOrganizationsController', ['$scope', '$http', '$timeout', function($scope, $http, $timeout) {

  var API = '/api/admin/organizations';

  $scope.organizations = [];
  $scope.isLoading     = true;
  $scope.showModal     = false;
  $scope.saving        = false;
  $scope.currentPage   = 1;
  $scope.itemsPerPage  = 10;
  $scope.totalItems    = 0;
  $scope.totalPages    = 0;
  $scope.searchQuery   = '';
  $scope.filterType    = '';
  $scope.editingOrg    = {};
  $scope.successMsg    = '';
  $scope.errorMsg      = '';

  var searchTimeout;

  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  $scope.load = function() {
    $scope.isLoading = true;
    var params = { page: $scope.currentPage - 1, size: $scope.itemsPerPage };
    if ($scope.searchQuery) params.search = $scope.searchQuery;
    if ($scope.filterType)  params.type   = $scope.filterType;

    $http.get(API, { params: params })
      .then(function(res) {
        var data = res.data;
        if (Array.isArray(data)) {
          $scope.organizations = data;
          $scope.totalItems    = data.length;
          $scope.totalPages    = Math.ceil(data.length / $scope.itemsPerPage) || 1;
        } else {
          $scope.organizations = data.content || [];
          $scope.totalItems    = data.totalElements || 0;
          $scope.totalPages    = data.totalPages || 1;
        }
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des organisations.'); })
      .finally(function() { $scope.isLoading = false; });
  };

  $scope.onSearch = function() {
    if (searchTimeout) $timeout.cancel(searchTimeout);
    searchTimeout = $timeout(function() { $scope.currentPage = 1; $scope.load(); }, 350);
  };

  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) return;
    $scope.currentPage = p; $scope.load();
  };

  $scope.getPages = function() {
    var pages = [], s = Math.max(1, $scope.currentPage - 2), e = Math.min($scope.totalPages, $scope.currentPage + 2);
    for (var i = s; i <= e; i++) pages.push(i);
    return pages;
  };

  $scope.openModal = function(org) {
    $scope.editingOrg = org ? angular.copy(org) : {};
    $scope.showModal  = true;
  };

  $scope.closeModal = function() { $scope.showModal = false; $scope.editingOrg = {}; };

  $scope.saveOrg = function() {
    if (!$scope.editingOrg.name) { flash('errorMsg', 'Le nom est obligatoire.'); return; }
    $scope.saving = true;
    var req = $scope.editingOrg.id
      ? $http.put(API + '/' + $scope.editingOrg.id, $scope.editingOrg)
      : $http.post(API, $scope.editingOrg);
    req.then(function() {
      $scope.closeModal(); $scope.load();
      flash('successMsg', $scope.editingOrg.id ? 'Organisation mise à jour.' : 'Organisation créée.');
    })
    .catch(function() { flash('errorMsg', 'Erreur lors de l\'enregistrement.'); })
    .finally(function() { $scope.saving = false; });
  };

  $scope.deleteOrg = function(org) {
    if (!confirm('Supprimer "' + org.name + '" ?')) return;
    $http.delete(API + '/' + org.id)
      .then(function() { $scope.load(); flash('successMsg', 'Organisation supprimée.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  $scope.load();
}]);
